"use client";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";

// Root boundary: rendered outside NextIntlClientProvider, so copy is inlined.
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const isDevelopment = process.env.NODE_ENV === "development";

  return (
    <div className="flex min-h-[60vh] items-center justify-center p-4">
      <Alert className="mx-auto w-full max-w-lg border-red-200 bg-red-50 p-6 dark:border-red-900 dark:bg-red-950/40">
        <div className="mb-2 flex items-center gap-2">
          <AlertCircle className="size-6 text-red-500" />
          <AlertTitle className="text-lg font-bold text-red-700 dark:text-red-300">
            Đã có lỗi xảy ra
          </AlertTitle>
        </div>
        <AlertDescription className="mb-4 text-sm leading-6 text-red-600 dark:text-red-400">
          Hệ thống không thể tải trang này. Vui lòng thử lại, nếu lỗi vẫn tiếp
          diễn hãy liên hệ bộ phận hỗ trợ.
        </AlertDescription>

        {/* Raw error details are for developers only — never shown to end users */}
        {isDevelopment && (
          <pre className="mb-4 max-h-40 overflow-auto whitespace-pre-wrap break-words rounded-md bg-red-100 p-3 text-xs text-red-700 dark:bg-red-950 dark:text-red-300">
            {error.message}
          </pre>
        )}
        {error.digest && (
          <p className="mb-4 text-xs text-red-500 dark:text-red-400">
            #{error.digest}
          </p>
        )}

        <Button
          variant="outline"
          className="border-red-300 text-red-700 hover:bg-red-100 dark:border-red-800 dark:text-red-300 dark:hover:bg-red-950"
          onClick={() => reset()}
        >
          Thử lại
        </Button>
      </Alert>
    </div>
  );
}
